import _objectSpread from "/workspace/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import { isCallScript, decodeCallScript } from '../callScript';
import { isValidForwardCall, parseForwardCall } from '../forwarding';
/**
 * Decodes an EVM callscript and returns the transaction path it describes.
 *
 * @return An array of Ethereum transactions that describe each step in the path
 */

export function decodeTransactionPath(script) {
  // In the future we may support more EVMScripts, but for now let's just assume we're only
  // dealing with call scripts
  if (!isCallScript(script)) {
    throw new Error("Script could not be decoded: ".concat(script));
  }

  var path = decodeCallScript(script);
  return path.reduce(function (decodeSegments, segment) {
    var data = segment.data;
    var children;

    if (isValidForwardCall(data)) {
      var forwardedEvmScript = parseForwardCall(data);

      try {
        children = decodeTransactionPath(forwardedEvmScript); // eslint-disable-next-line no-empty
      } catch (err) {}
    }

    return decodeSegments.concat(_objectSpread({}, segment, {
      children: children
    }));
  }, []);
}